import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginLayoutRoutes } from './login-layout.routing';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { NgxPaginationModule } from 'ngx-pagination';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule } from '@angular/common/http';
//import { AngularEditorModule } from '@kolkov/angular-editor';
import { CKEditorModule } from 'ckeditor4-angular';
//import { CKEditorComponent } from '@ckeditor/ckeditor5-angular'; 
import { CommonModule } from '@angular/common';
import { ForgotPasswordComponent } from '../../back-office/forgot-password/forgot-password.component';
import { SignUpComponent } from '../../back-office/sign-up/sign-up.component';
import { OTPVerificationComponent } from '../../back-office/otp-verification/otp-verification.component';
import { ResetPasswordComponent } from '../../back-office/reset-password/reset-password.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
    imports: [
        RouterModule.forChild(LoginLayoutRoutes),
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        MatButtonModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatTooltipModule,
        NgxPaginationModule,
        HttpClientModule,
        //AngularEditorModule,
        CKEditorModule,
        CommonModule,
        NgSelectModule,
        NgxMatSelectSearchModule,
    ],
    declarations: [
        SignUpComponent,
        OTPVerificationComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
    ]
})

export class LoginLayoutModule { }
